var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24x24/conrols_24x24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "controls"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector (Stroke)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 19.8335C9.5 19.2812 9.94772 18.8335 10.5 18.8335H21.8333C22.3856 18.8335 22.8333 19.2812 22.8333 19.8335C22.8333 20.3858 22.3856 20.8335 21.8333 20.8335H10.5C9.94772 20.8335 9.5 20.3858 9.5 19.8335Z",
    fill: "#2B303C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 19.8335C9.5 19.2812 9.94772 18.8335 10.5 18.8335H21.8333C22.3856 18.8335 22.8333 19.2812 22.8333 19.8335C22.8333 20.3858 22.3856 20.8335 21.8333 20.8335H10.5C9.94772 20.8335 9.5 20.3858 9.5 19.8335Z",
    fill: "#2B303C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 19.8335C1.5 19.2812 1.94772 18.8335 2.5 18.8335H4.5C5.05228 18.8335 5.5 19.2812 5.5 19.8335C5.5 20.3858 5.05228 20.8335 4.5 20.8335H2.5C1.94772 20.8335 1.5 20.3858 1.5 19.8335Z",
    fill: "#2B303C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8333 11.8335C18.8333 11.2812 19.281 10.8335 19.8333 10.8335H21.1667C21.719 10.8335 22.1667 11.2812 22.1667 11.8335C22.1667 12.3858 21.719 12.8335 21.1667 12.8335H19.8333C19.281 12.8335 18.8333 12.3858 18.8333 11.8335Z",
    fill: "#2B303C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 11.8335C1.5 11.2812 1.94772 10.8335 2.5 10.8335H13.8333C14.3856 10.8335 14.8333 11.2812 14.8333 11.8335C14.8333 12.3858 14.3856 12.8335 13.8333 12.8335H2.5C1.94772 12.8335 1.5 12.3858 1.5 11.8335Z",
    fill: "#2B303C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 3.8335C9.5 3.28121 9.94772 2.8335 10.5 2.8335H21.1667C21.719 2.8335 22.1667 3.28121 22.1667 3.8335C22.1667 4.38578 21.719 4.8335 21.1667 4.8335H10.5C9.94772 4.8335 9.5 4.38578 9.5 3.8335Z",
    fill: "#2B303C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3.8335C1.5 3.28121 1.94772 2.8335 2.5 2.8335H5.16667C5.71895 2.8335 6.16667 3.28121 6.16667 3.8335C6.16667 4.38578 5.71895 4.8335 5.16667 4.8335H2.5C1.94772 4.8335 1.5 4.38578 1.5 3.8335Z",
    fill: "#2B303C"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83333 2.5C7.09695 2.5 6.5 3.09695 6.5 3.83333C6.5 4.56971 7.09695 5.16667 7.83333 5.16667C8.56971 5.16667 9.16667 4.56971 9.16667 3.83333C9.16667 3.09695 8.56971 2.5 7.83333 2.5ZM4.5 3.83333C4.5 1.99238 5.99238 0.5 7.83333 0.5C9.67428 0.5 11.1667 1.99238 11.1667 3.83333C11.1667 5.67428 9.67428 7.16667 7.83333 7.16667C5.99238 7.16667 4.5 5.67428 4.5 3.83333Z",
    fill: "#2B303C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 10.5C15.7636 10.5 15.1666 11.097 15.1666 11.8333C15.1666 12.5697 15.7636 13.1667 16.5 13.1667C17.2363 13.1667 17.8333 12.5697 17.8333 11.8333C17.8333 11.097 17.2363 10.5 16.5 10.5ZM13.1666 11.8333C13.1666 9.99238 14.659 8.5 16.5 8.5C18.3409 8.5 19.8333 9.99238 19.8333 11.8333C19.8333 13.6743 18.3409 15.1667 16.5 15.1667C14.659 15.1667 13.1666 13.6743 13.1666 11.8333Z",
    fill: "#2B303C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83333 18.5C7.09695 18.5 6.5 19.097 6.5 19.8333C6.5 20.5697 7.09695 21.1667 7.83333 21.1667C8.56971 21.1667 9.16667 20.5697 9.16667 19.8333C9.16667 19.097 8.56971 18.5 7.83333 18.5ZM4.5 19.8333C4.5 17.9924 5.99238 16.5 7.83333 16.5C9.67428 16.5 11.1667 17.9924 11.1667 19.8333C11.1667 21.6743 9.67428 23.1667 7.83333 23.1667C5.99238 23.1667 4.5 21.6743 4.5 19.8333Z",
    fill: "#2B303C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.97013584ab986590a608f225bc1a3ed8.svg";
export { ForwardRef as ReactComponent };